<template lang="pug">
.v-news.news(v-if="data" :id="data?.id")
	.news__header
		.news__control.tags
			.tags__items(v-if="data.tabs")
				.tags__item(v-for="tab in data.tabs" @click="handleTabClick(tab)" :class="{'active': tab.id === activeTab.id}") {{tab.title}}
	.news__slider-wrap
		template(v-for="(tab, tabIndex) in data.tabs" :key="tabIndex")
			.news__slider(v-if="tab.items && tab.items.length" :class="{'news__slider--shown': tab.id === activeTab.id}")
				v-base-slider(:options="options" theme="dark")
					v-swiper-slide.swiper-slide(v-for="(slide, slideIndex) in tab.items" :key="slideIndex")
						v-news-card(:card="slide")
	.news__actions
		.news__actions(v-for="action in data.actions")
			a.news__action.btn(:href="action.link" :class="action.className") {{action.text}}
				v-svg-icon.btn__arrow(icon="arrow-right")
</template>

<script>

import sourceMixin from "./mixins/v-mixin-source.vue";
import isMobMixin from "./mixins/v-mixin-is-mob.vue";
import breakpoints from "../scripts/breakpoints.js";
import {SwiperSlide} from 'swiper/vue';

export default {

	components: {
		'v-swiper-slide': SwiperSlide
	},

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
			activeTab: null,
			options: {
				freeMode: true,
				watchOverflow: true,
				slidesPerView: 'auto',
				spaceBetween: 11,
				resizeObserver: true,
				loop: false,
				navigation: {
					prevEl: '.swiper-button-prev',
					nextEl: '.swiper-button-next'
				},
				breakpoints: {
					[breakpoints['tablet']]: {
						freeMode: false,
						slidesPerView: 3,
						spaceBetween: 27
					}
				}
			}
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
			if (this.data.tabs && this.data.tabs.length) {
				this.activeTab = this.data.tabs[0];
			}
		},

		handleTabClick(tab) {
			this.activeTab = tab;
		}
	}
}

</script>